export class DeviceInfo {
    platform: string;
    manufacturer: string;
    model: string;
    version: string;
};